// src/app/features/dashboard/widgets/ScarletWell/CheckIn/checkInHelpers.js

export function getSortedResponseOptions(responseOptions) {
  if (!responseOptions) {
    return []
  }

  return responseOptions
    .slice()
    .sort((left, right) => right.responseScore - left.responseScore)
}

export function getResponseLabel(responseOption) {
  return responseOption.responseTitle.replace(' True', '')
}

export function getAnswerScaleColumns(responseOptions) {
  return responseOptions
    .map((responseOption) => {
      const labelLength = getResponseLabel(responseOption).length + 2
      return `max(2.75rem, ${labelLength}ch)`
    })
    .join(' ')
}

export function getAnswerScaleLayoutStyle(responseOptions) {
  return {
    gridTemplateColumns: getAnswerScaleColumns(responseOptions),
  }
}

export function getCategoryLabel(category) {
  if (category.categoryTitle === 'Environment') {
    return 'Environmental'
  }

  return category.categoryTitle
}

export function getIncompleteCategoryIds(categories, selectedAnswers) {
  return categories
    .filter(
      (category) =>
        category.questions.length > 0 &&
        category.questions.some(
          (question) => selectedAnswers[question.questionId] == null,
        ),
    )
    .map((category) => category.categoryId)
}

export const handleCloseModal = ({ setIsModalOpen, history }) => {
  setIsModalOpen(false)
  history.push('/dashboard')
}

export const handleScrollToTop = (
  shouldFocus = true,
  { categoryPanelClass, isMdDown, setNeedsFocus },
) => {
  const categoryPanel = document.querySelector(`.${categoryPanelClass}`)
  if (categoryPanel) {
    // TODO: this number will need to change when latest backButtonNavBar is implemented due to size change
    const yOffset = -124
    const yOffsetMobile = 0
    const yOffsetToUse = isMdDown ? yOffsetMobile : yOffset
    const y =
      categoryPanel.getBoundingClientRect().top + window.scrollY + yOffsetToUse

    // Respect OS-level motion preferences
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches
    const scrollBehavior = prefersReducedMotion ? 'auto' : 'smooth'

    window.scrollTo({ top: y, behavior: scrollBehavior })

    if (shouldFocus) {
      // Flag that we need focus so the useEffect handles it cleanly after the render
      setNeedsFocus(true)
    }
  }
}

export const onPreviousCategory = (
  event,
  { categories, setSelectedCategoryId, scrollToTop },
) => {
  setSelectedCategoryId((prevId) => {
    if (!categories || categories.length === 0 || prevId == null) {
      return prevId
    }

    const activeIndex = categories.findIndex(
      (category) => category.categoryId === prevId,
    )

    if (activeIndex > 0) {
      return categories[activeIndex - 1].categoryId
    }
    return prevId
  })

  // A click event with a detail of 0 means it was triggered by a keyboard
  const isKeyboard = event ? event.detail === 0 : false
  scrollToTop(isKeyboard)
}

export const onNextCategory = (
  event,
  { categories, setSelectedCategoryId, scrollToTop },
) => {
  setSelectedCategoryId((prevId) => {
    if (!categories || categories.length === 0 || prevId == null) {
      return prevId
    }

    const activeIndex = categories.findIndex(
      (category) => category.categoryId === prevId,
    )

    if (activeIndex > -1 && activeIndex < categories.length - 1) {
      return categories[activeIndex + 1].categoryId
    }
    return prevId
  })

  // A click event with a detail of 0 means it was triggered by a keyboard
  const isKeyboard = event ? event.detail === 0 : false
  scrollToTop(isKeyboard)
}
